import { RadioGroupField, RadioGroupFieldProps } from 'components/form'
import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'

const options = [
  { value: RastreioCancerPerguntaOpcaoEnum.SIM, label: 'Sim' },
  { value: RastreioCancerPerguntaOpcaoEnum.NAO, label: 'Não' },
  { value: RastreioCancerPerguntaOpcaoEnum.NAO_SABE, label: 'Não sabe' },
]

export function SimNaoNaoSabeRadioField(
  props: Readonly<Omit<RadioGroupFieldProps<RastreioCancerPerguntaOpcaoEnum>, 'options'>>
) {
  return <RadioGroupField {...props} options={options} />
}
